var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 16.6L6.90969 20.3364C6.39495 20.8576 6.13757 21.1182 5.91634 21.1366C5.72441 21.1526 5.5365 21.0754 5.41115 20.9291C5.26667 20.7606 5.26667 20.3944 5.26667 19.6618V17.7899C5.26667 17.1328 4.72848 16.6572 4.07824 16.562C2.50449 16.3314 1.26854 15.0956 1.03802 13.5218C1 13.2623 1 12.9526 1 12.3333V6.76C1 4.74381 1 3.73571 1.39238 2.96564C1.73752 2.28825 2.28825 1.73752 2.96564 1.39238C3.73571 1 4.74381 1 6.76 1H15.64C17.6562 1 18.6642 1 19.4344 1.39238C20.1118 1.73752 20.6625 2.28825 21.0076 2.96564C21.4 3.73571 21.4 4.74381 21.4 6.76V11.8M21.4 25L18.7883 23.1843C18.4212 22.929 18.2376 22.8014 18.0378 22.7109C17.8605 22.6306 17.6741 22.5722 17.4827 22.5369C17.267 22.4972 17.0434 22.4972 16.5963 22.4972H14.44C13.0959 22.4972 12.4238 22.4972 11.9104 22.2356C11.4588 22.0055 11.0916 21.6383 10.8616 21.1868C10.6 20.6733 10.6 20.0013 10.6 18.6572V15.64C10.6 14.2959 10.6 13.6238 10.8616 13.1104C11.0916 12.6588 11.4588 12.2916 11.9104 12.0616C12.4238 11.8 13.0959 11.8 14.44 11.8H21.16C22.5041 11.8 23.1762 11.8 23.6896 12.0616C24.1412 12.2916 24.5084 12.6588 24.7384 13.1104C25 13.6238 25 14.2959 25 15.64V18.8972C25 20.0154 25 20.5745 24.8174 21.0156C24.5738 21.6036 24.1065 22.0709 23.5185 22.3144C23.0774 22.4972 22.5183 22.4972 21.4 22.4972V25Z",
    stroke: "#043F6C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic-chat.1c1dac82129af44a52ec5f145340f043.svg";
export { ForwardRef as ReactComponent };